import { styled } from 'styled-components'
import { ReactComponent as CloseSvg } from 'icons/assets/X.svg'
import { DYNAMIC_WALL_BG_MOBILE } from 'pages/AICreation/AICreationFlow/consts'

export const MOBILE_SHEET_HEIGHT = '92dvh'

export const POPUP_DIALOG_STYLES = {
  '& .MuiDialog-paper': {
    width: '560px',
    maxWidth: 'calc(100vw - 32px)',
    height: 'min(680px, calc(100dvh - 64px))',
    maxHeight: 'none',
    overflow: 'hidden',
  },
}

export const Content = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
`

export const Body = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  background: #f7f6f5 url(${DYNAMIC_WALL_BG_MOBILE}) center / cover no-repeat;
`

export const Header = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 24px 24px 0;
  color: ${({ theme }) => theme.colors.black};
  font-feature-settings: 'case' on;
  text-align: center;
`

export const CloseButton = styled.button`
  position: absolute;
  top: 29px;
  right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  background: none;
  color: ${({ theme }) => theme.colors.secondaryDark};
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
`

export const CloseIcon = styled(CloseSvg)`
  width: 32px;
  height: 32px;
`

// Clears the close button on both sides so the title stays centred.
export const Title = styled.h2`
  margin: 0;
  padding: 0 28px;
  font-size: 26px;
  font-weight: 600;
  line-height: 160%;
`

export const Subtitle = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 18px;
  font-weight: 500;
  line-height: 160%;
`

// Wraps as one unit, so a narrow sheet never strands the struck-through price on its own line.
export const PriceGroup = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
`

export const OriginalPrice = styled.span`
  text-decoration: line-through;
`

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px;
  border-top: 1px solid ${({ theme }) => theme.colors.grayAccent};
  background-color: ${({ theme }) => theme.colors.white};
`
